export const courseReportState = {
    selectedSemester: '',
    semesters: [],
    selectedTerm: '',
    terms: [],
    totalCourse: 0,
    groups: 0,
    tableHeader: 'Staff Progression Chart',
    tableColumn: ['Id', 'Course Name', 'Lecture', 'Lab hr', 'Tutorial hr', 'Cr hr', 'LEH'],
    tableData: [],
    tab: 0,
    load: 0,
    undergraduate: 0,
    postgraduate: 0,
    regular: 0,
    extension: 0,
    underload: 0,
    activeCourse: 0,
}